import { useCallback, useState } from 'react';

interface Params<T> {
  controlledValue?: T;
  defaultValue?: T;
  onChange?: (val: T) => void;
}

function useControlledState<T>({ controlledValue, defaultValue, onChange }: Params<T>) {
  const [internalState, setInternalState] = useState(defaultValue);
  const isControlled = controlledValue !== undefined;

  const setState = useCallback(
    (value: T) => {
      onChange?.(value);
      setInternalState(value);
    },
    [onChange],
  );

  const state = isControlled ? controlledValue : internalState;

  return [state, setState] as const;
}

export default useControlledState;
